var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUclaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "79px",
    height: "26px",
    viewBox: "0 0 79 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo_UCLA_blue@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Final",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Opt-2",
    transform: "translate(-680.000000, -10.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo_UCLA_blue",
    transform: "translate(680.133333, 10.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.377619048,18.2804762 C0.307226666,17.4043219 0.288622871,16.5247758 0.321904762,15.6464286 L1.57857143,1.40833333 L6.24309524,1.40833333 L4.9647619,15.7702381 C4.68928571,18.8654762 5.89333333,21.1002381 9.01333333,21.1002381 C12.1890476,21.1002381 13.8666667,18.8438095 14.1421429,16.0828571 L15.4669048,1.39904762 L20.1283333,1.39904762 L18.837619,15.912619 C18.317619,21.4840476 14.6157143,25.675 8.62333333,25.675 C3.95571429,25.675 0.947142857,22.6571429 0.37452381,18.2928571",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1992857,13.4580952 C21.8183333,6.61761905 26.4209524,0.947142857 34.3911905,0.947142857 C36.5639005,0.916444152 38.6964728,1.5339095 40.5166667,2.72071429 L39.9842857,8.36952381 C38.1457143,5.95214286 35.9604762,5.55904762 33.9454762,5.55904762 C28.9930952,5.55904762 26.2661905,9.00404762 25.8761905,13.3652381 C25.5016667,17.6088095 27.6930952,21.0630952 32.4969048,21.0630952 C34.5954762,21.0630952 36.8302381,20.4440476 39.1454762,18.1319048 L38.6316667,23.9292857 C36.3628571,25.167381 34.255,25.7183333 32.1316667,25.7183333 C24.245,25.7183333 20.6328571,19.8590476 21.1992857,13.4580952",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2402381,1.39904762 L48.8830952,1.39904762 L47.1869048,20.7442857 L53.8509524,20.7442857 C54.3214286,20.7442857 55.9092857,20.7195238 56.3271429,20.6947619 C56.302381,20.9269048 55.9030952,25.1642857 55.9030952,25.1642857 L42.1292857,25.1642857 L44.2402381,1.39904762 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4728571,10.27 C68.6186256,9.94938398 68.7336643,9.6156682 68.8164286,9.27333333 L68.8907143,9.27333333 C68.9190282,9.61329021 68.978079,9.94998343 69.0671429,10.2792857 C69.3240476,11.362619 71.1347619,17.3797619 71.1347619,17.3797619 L65.2538095,17.3797619 C65.2538095,17.3797619 68.4016667,10.4278571 68.4635714,10.2607143 L68.4728571,10.27 Z M69.6552381,0.300238095 L69.3457143,0.300238095 L56.6088095,25.1488095 L61.5611905,25.1488095 L63.3440476,21.3942857 L72.3202381,21.3942857 L73.4407143,25.1642857 L78.3714286,25.1642857 L69.6552381,0.300238095 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUclaLogo);
export default __webpack_public_path__ + "static/media/UCLA-logo.88bd29a0fc441c7d70f3e3def8bbeeff.svg";
export { ForwardRef as ReactComponent };